import type { ReactNode } from 'react'

export const ROUTES = {
  INFRA: '/infra',
  INFRA_DATACENTERS: '/infra/datacenters',
  INFRA_CLUSTERS: '/infra/clusters', 
  INFRA_SERVERS: '/infra/servers',
  INFRA_NETWORK: '/infra/network',
} as const

export const ROUTES_TITLES: Record<string, string> = {
  [ROUTES.INFRA]: 'Infrastructure',
  [ROUTES.INFRA_DATACENTERS]: 'Datacenters',
  [ROUTES.INFRA_CLUSTERS]: 'Clusters',
  [ROUTES.INFRA_SERVERS]: 'Servers', 
  [ROUTES.INFRA_NETWORK]: 'Network',
}

export type ItemConfig = {
  path: string
  icon?: ReactNode
  label: string
  title: string
  submenu?: ItemConfig[]
  exact?: boolean
  href?: string
  capability?: string
  footer?: boolean
}
